<template>
    <div class="row">
        <div class="col-12">
            <div class="panel-sub-heading headingSmall ">
                <span class="markedBottom">
                    {{label}}
                    <a v-if="helpContent !== ''" data-popover-placement="bottom" :data-popover-title="helpContent.split('||')[0]" :data-popover-content="helpContent.split('||')[1]" href="#" class="helpBtn addPopover helpHeader activePopover" data-original-title="" title=""><i tabindex="-1" class="fa fa-info-circle"></i></a>
                </span>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group" :class="hasError">
                <label v-for="(option, index) in options" class="marginRight10" :class="{checked:isChecked(option), displayBlock:asBlock, disabled:!!disabled}" :equal="isChecked(option)" :for="id + '_option_' + index" :disabled="!!disabled">
                    <span class="paddingRight15">
                      <button type="button"
                              class="btn form-control"
                              @click="changeInput(option)"
                              :class="{'btn-default': isChecked(option), 'btn-unchecked': !isChecked(option),  displayBlock:asBlock, disabled:!!disabled}"
                              :for="`id_${name}_option_${index}`"
                              :disabled="!!disabled">
                        {{option.label}}
                    </button>
                    </span>
                </label>
            </div>
            <np-radios
                    :class="'displayNone'"
                    :id="name"
                    :name="name"
                    :no-wrapper="false"
                    :options="options"
                    v-model="currentValue">
            </np-radios>
        </div>
    </div>
</template>

<script>
    import NPResponsive from './np-responsive.vue';
    import {NPRadios} from "./index";
    export default {
        name: 'np-button-radios',
        mixins: [NPRadios, NPResponsive],
        props: {
            options: Array,
            asBlock: {
                type: Boolean,
                default: false
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            id: {
                required: true
            },
            helpContent:{
                type: String,
                default: ''
            },
            disabled: false,
            required: false,
            name: String,
            submitted: false
        },
        data: function() {
            return  {
                currentValue: ''
            }
        },
        created: function () {
            this.currentValue = '';
        },
        methods: {
            changeInput: function (option) {
                if(this.currentValue !== option.value) {
                    this.currentValue = option.value;
                    this.$emit('update:modelValue', option.value);
                }
                let a = this.$refs.form_group
            },
            isChecked: function(option) {
                return option.value === this.value;
            }
        },
        computed: {
            hasError: function() {
                return {
                    'has-error': this.submitted && this.currentValue === ''
                }
            }
        }
    }
</script>

<style scoped>
    [type="radio"] {
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px; margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
    }
</style>
